import React from 'react';
import { Link } from 'react-router-dom';
import FullLogo from '../Photos/Fulllogo.png';
import GeneralImage from '../Photos/generalimage.jpg';
import Bunks1 from '../Photos/bunk1.jpg';
import Panels1 from '../Photos/Panels1.jpg';
import Panels2 from '../Photos/Panels2.jpg';
import Balefeeder1 from '../Photos/Balefeeder1.jpg';
import Balefeeder2 from '../Photos/Balefeeder2.jpg';
import Ufeederpanel from '../Photos/Ufeederpanel.jpg'
import Continuous1 from '../Photos/Continuous1.jpg';
import Continuous2 from '../Photos/Continuous2.jpg';
import Custom1 from '../Photos/Custom1.jpg';
import Driveover3 from '../Photos/driveover3.jpg';
import Gates2 from '../Photos/gates2.jpg';
import Feederpanel1 from '../Photos/feederpanels1.jpg';
import feederpanel3 from '../Photos/feederpanel3.jpg';
import Custom4 from '../Photos/custom4.jpg';
import Main from '../Photos/Main.png';
import Custom7 from '../Photos/Custom7.jpg';
import Custom8 from '../Photos/Custom8.jpg';
import Custom9 from '../Photos/Custom9.jpg';
import Freestanding from '../Photos/Freestanding.jpg';

function Home() {
  return (
    <div className="container mt-5">
       {/*Main Logo Image*/} 
      <div className="full-width-image">
        <img src={FullLogo} alt="Full Width Header" className="img-fluid" />
      </div>

      {/* Carousel Section with 7 Items */}
      <div id="homeCarousel" className="carousel slide" data-bs-ride="carousel">
        <div className="carousel-inner">
          <div className="carousel-item active">
           <img src={Main} className="d-block w-100" alt="Slide 1" />
            <div className="carousel-caption d-none d-md-block">
              <h5>Welcome</h5>
              <p>Continue to explore our solutions</p>
            </div>
          </div>
          <div className="carousel-item">
            <img src={Balefeeder1} className="d-block w-100" alt="Slide 2" />
            <div className="carousel-caption d-none d-md-block">
              <h5>Bale Feeders</h5>
            </div>
          </div>
          <div className="carousel-item">
            <img src={Bunks1} className="d-block w-75" alt="Slide 3" />
            <div className="carousel-caption d-none d-md-block">
              <h5>Bottomless Bunks</h5>
            </div>
          </div>
          <div className="carousel-item">
            <img src={feederpanel3} className="d-block w-100" alt="Slide 4" />
            <div className="carousel-caption d-none d-md-block">
              <h5>Feeder Panels</h5>
            </div>
          </div>
          <div className="carousel-item">
            <img src={Driveover3} className="d-block w-75" alt="Slide 5" />
            <div className="carousel-caption d-none d-md-block">
              <h5>Driveover Gates</h5>
            </div>
          </div>
          <div className="carousel-item">
            <img src={Panels1} className="d-block w-100" alt="Slide 6" />
            <div className="carousel-caption d-none d-md-block">
              <h5>Freestanding Panels</h5>
            </div>
          </div>
          <div className="carousel-item">
            <img src={Gates2} className="d-block w-100" alt="Slide 7" />
            <div className="carousel-caption d-none d-md-block">
              <h5>Gates</h5>

            </div>
          </div>
        </div>
        <button className="carousel-control-prev" type="button" data-bs-target="#homeCarousel" data-bs-slide="prev">
          <span className="carousel-control-prev-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Previous</span>
        </button>
        <button className="carousel-control-next" type="button" data-bs-target="#homeCarousel" data-bs-slide="next">
          <span className="carousel-control-next-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Next</span>
        </button>
        <div className="carousel-indicators">
          <button type="button" data-bs-target="#homeCarousel" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
          <button type="button" data-bs-target="#homeCarousel" data-bs-slide-to="1" aria-label="Slide 2"></button>
          <button type="button" data-bs-target="#homeCarousel" data-bs-slide-to="2" aria-label="Slide 3"></button>
          <button type="button" data-bs-target="#homeCarousel" data-bs-slide-to="3" aria-label="Slide 4"></button>
          <button type="button" data-bs-target="#homeCarousel" data-bs-slide-to="4" aria-label="Slide 5"></button>
          <button type="button" data-bs-target="#homeCarousel" data-bs-slide-to="5" aria-label="Slide 6"></button>
          <button type="button" data-bs-target="#homeCarousel" data-bs-slide-to="6" aria-label="Slide 7"></button>
        </div>
      </div>

      {/* Introduction Section */}
      <div className="row mt-5 mb-5">
        <div className="col-md-8">
          <h2 className="text-success">Our Motto</h2>
          <p className="lead">Built for your farm, like it was built for ours</p>
          <p className="text-muted">Explore to learn about our products and services</p>
        </div>
        <div className="col-md-4">
          
        </div>
      </div>

      {/* Informational Box */}
      <div className="card mb-5 shadow-sm get-in-touch-card">
        <div className="row g-0">
          <div className="col-md-4">
            <img src={Balefeeder1} className="img-fluid rounded-start" alt="Info Image" />
          </div>
          <div className="col-md-8">
            <div className="card-body">
              <h4 className="card-title text-primary">Bale Feeders</h4>
              <p className="card-text">Tired of wasting hay and rusted-out bale feeders? Our bale feeders have a bottom structure made from thick-wall oilfield pipe and have custom bent bars that prevent hay loss while minimizing the risk of trapping animals. Our single or double bale feeders minimize hay loss and are built to last a lifetime.</p>
              <button className="btn-custom">
                <Link to="/balefeeder" style={{ color: 'inherit', textDecoration: 'none' }}>Learn More</Link>
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Informational Box with Image on Right */}
      <div className="card mb-5 shadow-sm get-in-touch-card">
        <div className="row g-0">
          <div className="col-md-8">
            <div className="card-body">
              <h4 className="card-title text-primary">Bottomless Bunks</h4>
              <p className="card-text">Whether feeding on the ground or in tires, improve your feeding efficiency with our bottomless bunks. Our bunks are designed for both in-lot and fence-line feeding to maximize bunk space. Built to be picked up and moved, manure management is a breeze, and the same bunk can be used on stocks and for springtime calving!! </p>
              <button className="btn-custom">
                <Link to="/bottemlessbunks" style={{ color: 'inherit', textDecoration: 'none' }}>Learn More</Link>
              </button>
            </div>
          </div>
          <div className="col-md-4">
            <img src={Bunks1} className="img-fluid rounded-end" alt="Info Image" />
          </div>
        </div>
      </div>

      {/* Informational Box */}{/*
      <div className="card mb-5 shadow-sm get-in-touch-card">
        <div className="row g-0">
          <div className="col-md-4">
            <img src={Continuous1} className="img-fluid rounded-start" alt="Info Image" />
          </div>
          <div className="col-md-8">
            <div className="card-body">
              <h4 className="card-title text-primary">Continuous Fence Pannels</h4>
              <p className="card-text">Building a high-quality fence has never been faster or simpler. With our pre-manufactured fence panels, you can build the fence you need with the time and resources you possess. </p>
              <button className="btn-custom">
                <Link to="/continuouspannels" style={{ color: 'inherit', textDecoration: 'none' }}>Learn More</Link>
              </button>
            </div>
          </div>
        </div>
      </div>
      */}

            {/* Informational Box */}
      <div className="card mb-5 shadow-sm get-in-touch-card">
        <div className="row g-0">
          <div className="col-md-4">
            <img src={feederpanel3} className="img-fluid rounded-start" alt="Info Image" />
          </div>
          <div className="col-md-8">
            <div className="card-body">
              <h4 className="card-title text-primary">Feeder Panels</h4>
              <p className="card-text">Whether looking for portable feeding solutions or mobility for manure management our feeder panels will make a great addition to you operation.  </p>
              <button className="btn-custom">
                <Link to="/Feederpanels" style={{ color: 'inherit', textDecoration: 'none' }}>Learn More</Link>
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Informational Box with Image on Right */}
      <div className="card mb-5 shadow-sm get-in-touch-card">
        <div className="row g-0">
          <div className="col-md-8">
            <div className="card-body">
              <h4 className="card-title text-primary">Driveover Gates</h4>
              <p className="card-text">Tired of opening and closing gates you drive through frequently? No Longer!! Our drive over gates are made so that you never have to leave the vehicle just approach and drive on through. Never have the gate left oppen again!!</p>
              <button className="btn-custom">
                <Link to="/driveovergates" style={{ color: 'inherit', textDecoration: 'none' }}>Learn More</Link>
              </button>
            </div>
          </div>
          <div className="col-md-4">
            <img src={Driveover3} className="img-fluid rounded-end" alt="Info Image" />
          </div>
        </div>
      </div>

      {/* Informational Box */}
      <div className="card mb-5 shadow-sm get-in-touch-card">
        <div className="row g-0">
          <div className="col-md-4">
            <img src={Freestanding} className="img-fluid rounded-start" alt="Info Image" />
          </div>
          <div className="col-md-8">
            <div className="card-body">
              <h4 className="card-title text-primary">Freestanding Panels</h4>
              <p className="card-text">Do you want an adaptable fencing solution that works? Our full-frame free-standing panels will give lots, pens, or dividers wherever you need them. Just set in place and GO!!</p>
              <button className="btn-custom">
                <Link to="/freestandingpannels" style={{ color: 'inherit', textDecoration: 'none' }}>Learn More</Link>
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Informational Box with Image on Right */}
      <div className="card mb-5 shadow-sm get-in-touch-card">
        <div className="row g-0">
          <div className="col-md-8">
            <div className="card-body">
              <h4 className="card-title text-primary">Gates</h4>
              <p className="card-text">Have a spot, we're your one stop. Our custom gates can be made in standard lengths or fit to meet your needs. Design to be mounted, having a freeswinging gate is easy.</p>
              <button className="btn-custom">
                <Link to="/gates" style={{ color: 'inherit', textDecoration: 'none' }}>Learn More</Link>
              </button>
            </div>
          </div>
          <div className="col-md-4">
            <img src={Gates2} className="img-fluid rounded-end"/>
          </div>
        </div>
      </div>

      {/* Informational Box */}
      <div className="card mb-5 shadow-sm get-in-touch-card">
        <div className="row g-0">
          <div className="col-md-4">
            <img src={Custom8} className="img-fluid rounded-start" alt="Info Image" />
          </div>
          <div className="col-md-8">
            <div className="card-body">
              <h4 className="card-title text-primary">Purpose Built</h4>
              <p className="card-text">Didn't see exactly what you needed? No worries we can build the perfect solution for you!!</p>
              <button className="btn-custom">
                <Link to="/purposebuilt" style={{ color: 'inherit', textDecoration: 'none' }}>Learn More</Link>
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Additional Images */}
      <div className="row g-4 mb-5">
        <div className="col-md-4">
          <img src={Custom9} alt="Image 1" className="img-fluid rounded shadow" />
          <p className="text-center mt-2"></p>
        </div>
        <div className="col-md-4">
          <img src={Feederpanel1} alt="Image 2" className="img-fluid rounded shadow" />
          <p className="text-center mt-2"></p>
        </div>
        <div className="col-md-4">
          <img src={Custom7} alt="Image 3" className="img-fluid rounded shadow" />
          <p className="text-center mt-2"></p>
        </div>
      </div>

       {/* Google Maps and Address Section */}
      <div className="row mb-5">
        <div className="col-md-6">
          <h3 className="text-info mb-3">Find Us on the Map</h3>
          <iframe
            title="Google Map Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d137778.5034484805!2d-96.8170804273567!3d40.26456281736707!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x879642a907fb410b%3A0x92e39ab059d18d3d!2sBeatrice%2C%20NE%2068310!5e0!3m2!1sen!2sus!4v1756762112857!5m2!1sen!2sus" 
            width="100%"
            height="400"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
          ></iframe>
        </div>
        <div className="col-md-6 d-flex flex-column">
          <h3 className="text-info mb-3">Contact Us</h3>
          <div className="card p-3 enlarged-address-card flex-grow-1">
            <p className="card-text">
         Location: <br />
              
            
              Beatrice, NE 68310<br />
              <br />
              <br />
              Email: eoltmans3@gmail.com<br />
              <br />
              Phone: (402) 239-4323
            </p>
          </div>
          <div className="flex-grow-1 mt-3">
            <img src={FullLogo} alt="Company Logo" className="img-fluid w-100" style={{ width: '100%', objectFit: 'cover' }} />
          </div>
        </div>
      </div>

      {/* Navigation Buttons */}
      <div className="text-center">
        <button className="btn-custom me-3">
          <Link to="/about" style={{ color: 'inherit', textDecoration: 'none' }}>Learn About Us</Link>
        </button>
        <button className="btn-custom me-3">
          <Link to="/PurposeBuilt" style={{ color: 'inherit', textDecoration: 'none' }}>Build For You!!</Link>
        </button>
      </div>
    </div>
  );
}

export default Home;